export const AUCTION_MODULE_PDP = 'auctionModuleDlosPDP';
export const BUY_PERSONALIZED_SEARCH_ITEMS = 'BUY_PERSONALIZED_SEARCH_ITEMS';
export const AUCTION_SIDERAIL_REDESIGN = 'AuctionPDPSiderail';
export const DISABLE_TOP_YMAL_PDP = 'disableTopYmalPdp';
